import React, { useReducer, useState } from 'react'
import { CustomInput } from '../../../../../components/CustomInput/CustomInput';
import {
    onInputChange,
    onFocusOut,
    formsReducer,
    fillFormAction,
    validateForm,
    updateFormAction
} from '../../../../../helpers/formUtils';
import { useDispatch } from 'react-redux';
import { showLoaderAction, hideLoaderAction } from '../../../../../redux/actions';
import { CustomButton } from '../../../../../components/CustomButton/CustomButton';
import { editSpaceMainInfo } from '../../../../../crud/spaces/spaces';
import { CustomRadio } from '../../../../../components/CustomRadio/CustomRadio';
import { useEffect } from 'react';
import { CustomTextArea } from '../../../../../components/CustomTextArea/CustomTextArea';
import { reduceFormData } from '../../../../../helpers/reduceFormData';
import GooglePlacesAutocomplete from 'react-google-places-autocomplete';

const initialState = {
    name: { value: '', touched: false, hasError: true, error: '' },
    presentedBy: { value: '', touched: false, hasError: true, error: '' },
    addressFull: { value: '', touched: false, hasError: true, error: '' },
    addressVisibility: { value: { name: 'None', value: 'none' }, touched: false, hasError: true, error: '' },
    externalUrl: { value: '', touched: false, hasError: true, error: '' },
    summary: { value: '', touched: false, hasError: true, error: '' },
    isFormValid: false,
};

export const TitleAndAddressTab = ({ spaceData, edited, setEdited, handleCancelModal, closeModule, handleSuccessModal, setSpaceData }) => {
    const dispatch = useDispatch();
    const [formData, setFormData] = useReducer(formsReducer, initialState);
    const [isError, setIsError] = useState(false)

  const validateAdress = () =>{
    if(!formData?.addressFull?.value?.label) setIsError(true)
    return !!formData?.addressFull?.value?.label
    }


    useEffect(() => {
        if (spaceData) {
            let addressVisibility =
                spaceData.addressVisibility === 'full'
                    ? { name: 'Full Address', value: 'full' }
                    : spaceData.addressVisibility === 'partial'
                        ? { name: 'City Only', value: 'partial' }
                        : spaceData.addressVisibility === 'none'
                            ? { name: 'None', value: 'none' }
                            : { name: '', value: '' }
            setFormData(fillFormAction({
                name: { value: spaceData.name, touched: false, hasError: true, error: '' },
                presentedBy: { value: spaceData.presentedBy, touched: false, hasError: true, error: '' },
                addressFull: { value: {
                    label:spaceData.address?.description || '',
                    value:spaceData.address || {},
                  }, touched: false, hasError: true, error: '' },
                addressVisibility: { value: addressVisibility, touched: false, hasError: true, error: '' },
                externalUrl: { value: spaceData.externalUrl, touched: false, hasError: true, error: '' },
                summary: { value: spaceData.summary, touched: false, hasError: true, error: '' },
                isFormValid: false,
            }));
        }
    }, [spaceData]);

    const submitForm = () => {
        if (validateForm(formData, setFormData) && validateAdress()) {
            dispatch(showLoaderAction());
            let reducedState = reduceFormData(formData);
            if(!reducedState.summary){
              reducedState.summary = '';
            }
            reducedState.address = reducedState.addressFull
            delete reducedState.addressFull
            editSpaceMainInfo(location.pathname.split('/')[3], reducedState)
                .then(() => {
                    dispatch(hideLoaderAction());
                    handleSuccessModal();
                    setSpaceData(prev=>({...prev,...reducedState}))
                })
        }
    };
    const handleAutocomplete = (e,...props)=>{
      setEdited(true);
      setIsError(false)
      onInputChange("addressFull", e, setFormData, formData);

    }

  const handleBlue = (e,...props)=>{
    validateAdress()
  }

    return (
        <>
            <div className="space-tab__input-container">
                <h2 className='space-tab__title'>Main Info</h2>

                <div className="space-tab__input-name">Title</div>
                <CustomInput
                    name="name"
                    formData={formData.name}
                    onChange={e => {
                        setEdited(true);
                        onInputChange("name", e.target.value, setFormData, formData);
                    }}
                    onBlur={e => {
                        onFocusOut("name", e.target.value, setFormData, formData)
                    }}
                    variantError="topright"
                />

                <div className="space-tab__input-name">Presented By</div>
                <CustomInput
                    name="presentedBy"
                    formData={formData.presentedBy}
                    onChange={e => {
                        setEdited(true);
                        onInputChange("presentedBy", e.target.value, setFormData, formData);
                    }}
                    onBlur={e => onFocusOut("presentedBy", e.target.value, setFormData, formData)}
                    variantError="topright"
                />

                <div className="space-tab__input-name">Public Address</div>
               {/* <CustomInput
                    name="address"
                    formData={formData.address}
                    onChange={e => {
                        setEdited(true);
                        onInputChange("address", e.target.value, setFormData, formData);
                    }}
                    onBlur={e => onFocusOut("address", e.target.value, setFormData, formData)}
                    variantError="topright"
                />*/}
                <div className={`${isError ? 'space-tab__autocomplete-error' : ''}`}>
                  <GooglePlacesAutocomplete
                    apiKey={process.env.REACT_APP_GOOGLE_KEY}
                    selectProps={{
                      value : formData?.addressFull?.value,
                      onChange: handleAutocomplete,
                      onBlur:handleBlue,
                      placeholder:'',
                      isClearable:true,
                      styles:{
                        control: (defaultStyles,state) => ({
                          ...defaultStyles,
                          border: "none",
                          fontSize:"14px",
                          boxShadow: "none",
                          backgroundColor:'#f6f7f8'
                        }),
                      }
                    }}
                  />
                  {isError &&
                    <p className='space-tab__autocomplete-error-text'>
                      This field is required
                    </p>
                  }
                </div>
            </div>

            <h2 className='space-tab__title'>Address Visibility</h2>
            <CustomRadio
                data={[
                    { name: 'Full Address', value: 'full' },
                    { name: 'City Only', value: 'partial' },
                    { name: 'None', value: 'none' }
                ]}
                onChange={value => {
                    setEdited(true);
                    onInputChange("addressVisibility", value, setFormData, formData);
                }}
                value={formData.addressVisibility.value}
            />

            <div className="space-tab__input-name">External Website</div>
            <CustomInput
                name="externalUrl"
                formData={formData.externalUrl}
                onChange={e => {
                    setEdited(true);
                    onInputChange("externalUrl", e.target.value, setFormData, formData);
                }}
                onBlur={e => onFocusOut("externalUrl", e.target.value, setFormData, formData)}
                variantError="topright"
            />

            <div className="space-tab__input-name">Summary</div>
            <div className='space-tab__textarea'>
                <CustomTextArea
                    name="summary"
                    formData={formData.summary}
                    onChange={e => {
                        setEdited(true);
                        onInputChange("summary", e.target.value, setFormData, formData);
                    }}
                    onBlur={e => onFocusOut("summary", e.target.value, setFormData, formData)}
                    variantError="topright"
                />
            </div>

            <div className='space-tab__buttons'>
                <div className="space-tab__cancel-btn">
                    <CustomButton
                        name="Cancel"
                        variant="grey"
                        onClick={(e) => {
                            e.preventDefault();
                            if (edited) {
                                handleCancelModal();
                            } else {
                                closeModule();
                            }
                        }}
                    />
                </div>
                <div className="space-tab__submit-btn">
                    <CustomButton
                        variant="green"
                        name="Save"
                        onClick={(e) => {
                            e.preventDefault();
                            submitForm();
                        }}
                    />
                </div>
            </div>
        </>
    )
};
